import axios from 'axios';

const API_BASE = import.meta.env.VITE_CRM_API_BASE || '/api';
const API_TIMEOUT = 30000;
const DEV_BEARER_TOKEN = import.meta.env.VITE_CRM_BEARER_TOKEN;
const LEGACY_SESSION_TOKEN_STORAGE_KEY = 'ezflow.crm.sessionToken';

export function clearStoredSessionToken() {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem(LEGACY_SESSION_TOKEN_STORAGE_KEY);
}

export const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  if (DEV_BEARER_TOKEN) {
    config.headers.Authorization = `Bearer ${DEV_BEARER_TOKEN}`;
  }
  return config;
});
